import { render, staticRenderFns } from "./horBarSetup.vue?vue&type=template&id=109b65ba&scoped=true&"
import script from "./horBarSetup.vue?vue&type=script&lang=js&"
export * from "./horBarSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109b65ba",
  null
  
)

export default component.exports